import React from "react";
import { Bar, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { useSelector, useDispatch } from "react-redux";
import {
  setActiveReport,
  setFromDate,
  setToDate,
  setFilter,
  setReportType,
  setReportData,
} from "../../../state/reducers/revenueReportSlice"; // Adjust path accordingly
import MonthlyRevenueChart from "./MonthlyRevenueChart";
import TotalRevenueReport from "./TotalRevenueReport";
import CountrywiseRevenueChart from "./CountrywiseRevenueChart";
import ServicewiseRevenueChart from "./ServicewiseRevenueChart";
import LeadRevenueChart from "./LeadRevenueChart";

// Register Chart.js components
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const RevenueReport = () => {
  const dispatch = useDispatch();
  const { activeReport, fromDate, toDate, filter, reportType, reportData } =
    useSelector((state) => state.revenueReport);
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);

  const reports = [
    "Service-wise Revenue",
    "Month-wise Revenue",
    "Country-wise Revenue",
    "Level of Study-wise Revenue",
    "Total Revenue",
  ];

  // Render the chart dynamically based on the selected report
  const renderChart = (report) => {
    if (report === "Month-wise Revenue") {
      return <MonthlyRevenueChart />; // Render MonthlyRevenueChart component
    }
    if (report === "Total Revenue") {
      return <TotalRevenueReport />;
    }
    if (report === "Country-wise Revenue") {
      return <CountrywiseRevenueChart />;
    }
    if (report === "Service-wise Revenue") {
      return <ServicewiseRevenueChart />;
    }
    if (report === "Level of Study-wise Revenue") {
      return <LeadRevenueChart />;
    }
    const data = reportData[report];
    const ChartType =
      report === "Month-wise Revenue" || report === "Total Revenue"
        ? Line
        : Bar;

    return (
      <ChartType
        data={data}
        options={{
          responsive: true,
          plugins: {
            legend: { display: true },
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        }}
      />
    );
  };

  // Sample data to be displayed in List view
  const sampleListData = [
    { service: "Service A", revenue: 5000 },
    { service: "Service B", revenue: 7000 },
    { service: "Service C", revenue: 4000 },
    { service: "Service D", revenue: 8000 },
    { service: "Service E", revenue: 6000 },
  ];

  // Function to handle report generation with the provided filters

  // Render the list of data
  const renderList = () => (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h3 className="text-xl font-semibold mb-4">Revenue List</h3>
      <table className="min-w-full">
        <thead>
          <tr>
            <th className="px-4 py-2 text-left">Service</th>
            <th className="px-4 py-2 text-left">Revenue</th>
          </tr>
        </thead>
        <tbody>
          {sampleListData.map((item, index) => (
            <tr key={index}>
              <td className="px-4 py-2">{item.service}</td>
              <td className="px-4 py-2">{item.revenue}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    <div
      className={`flex-1 bg-white ${
        isSideBarOpen ? "ml-80" : "ml-20"
      } min-h-screen`}
    >
      <div className="container mx-auto p-6">
        <h1 className="text-3xl font-bold mb-6">Revenue Report</h1>

        {/* Report Menu */}
        <div className="flex flex-wrap space-x-6 mb-8">
          {reports.map((report) => (
            <button
              key={report}
              className={`px-4 py-2 rounded ${
                activeReport === report
                  ? "bg-blue-500 text-white"
                  : "bg-gray-200 text-gray-800"
              }`}
              onClick={() => dispatch(setActiveReport(report))}
            >
              {report}
            </button>
          ))}
        </div>

        {/* Filters and Generate Button */}
        <div className="mb-8">
          {/* <div className="flex flex-wrap items-center space-x-6 mb-8">
            <div>
              <label className="block text-sm font-semibold mb-2">
                From Date
              </label>
              <input
                type="date"
                className="border border-gray-300 rounded px-4 py-2 w-full"
                value={fromDate}
                onChange={(e) => dispatch(setFromDate(e.target.value))}
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                To Date
              </label>
              <input
                type="date"
                className="border border-gray-300 rounded px-4 py-2 w-full"
                value={toDate}
                onChange={(e) => dispatch(setToDate(e.target.value))}
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">Filter</label>
              <select
                className="border border-gray-300 rounded px-4 py-2 w-full"
                value={filter}
                onChange={(e) => dispatch(setFilter(e.target.value))}
              >
                <option>This filtered period Lead</option>
                <option>All Leads</option>
                <option>New Leads</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-semibold mb-2">
                Report Type
              </label>
              <select
                className="border border-gray-300 rounded px-4 py-2 w-full"
                value={reportType}
                onChange={(e) => dispatch(setReportType(e.target.value))}
              >
                <option>Analytics</option>
                <option>List</option>
              </select>
            </div>
            <div className="flex items-end">
              <button
                onClick={handleGenerate}
                className="bg-blue-500 text-white px-4 py-2 mt-6 rounded"
              >
                Generate
              </button>
            </div>
          </div> */}

          {/* Conditionally render either the chart or the list */}
          {reportType === "Analytics"
            ? renderChart(activeReport)
            : renderList()}
        </div>
      </div>
    </div>
  );
};

export default RevenueReport;
